import { Medscape } from 'www/medscape';
import { VideoLoader } from 'www/modules/video/video-loader';
import { SponsoredVideo } from 'www/modules/video/sponsored-video';
import { Playlist } from './modules/recap/playlist';
import { getSecondsFromTimeString } from 'www/utils/get-seconds-from-time-string';
import { ArticlePoll } from 'www/modules/article-poll';
import { PlayListAPI } from './modules/recap/filmstrip/recap-filmstrip';
import { StickyVideo } from './modules/common/sticky-video/sticky-video';
import { CommonSVPLoadModule as SVPLoader } from '../../modules/svpload/common-svp-load-module';
import { cpArticleLoad } from 'www/modules/cp/cp-article-load';
import { MmmAppDriver } from './modules/recap/mmm-app';

export default class MedicalMinutesArticle {
    constructor(el) {
        this.el = el;
        window._isMedicalMinutes = true
        this._player = null;
        this.PlayerReadyCallbacks = [];
        this.playlistVideos = [];
        this.nextVideoIndex = 0;
        this.nextVideoUrl = "";
        this.nextVideoTitle = "";
        this.sticky = {};
        this.setAboutHoverContent();
        this.loadAds();
        this.hideBreadCrumb();
        this.addEventListnerForIFI();
        // To enable recap sponsored IFI video
        Medscape.RecapArticle = this;
        this.mmmApp = new MmmAppDriver();
    }
    get player() {
        if (this._player == null) {
            let container = document.querySelector('.streaming-video-player');
            if (container != null) {
                this._player = container.amp;
            }
        }
        return this._player;
    }
    set player(player = null) {
        this._player = player;
    }
    
    init() {
        let playListApi = new PlayListAPI();

        try {
            this.insert800Ad('800', 800).insert800Ad('1800', 1800);
        } catch (error) {
            console.log(error);
        }
        ArticlePoll.init();
            this.loadVideo().then(event => {
                let { player } = event;
                window.player = player;
                this.player = player;
                this.sticky = new StickyVideo("#eed-video .svp-module", $("h1.title").text());
                this.sticky.init();
                this.PlayerReadyCallbacks.forEach( cb => {
                    cb();
                })
            },
            error => {
                console.error("Load Video Error:", error);
            }); 
        if (PageMetadata.pageSegVars.ctype == '20171') {
            cpArticleLoad('carecues');
        } else {
            cpArticleLoad('recap');
        }
        this.mmmApp.addFab();

    }
    loadVideo() {

        const { s_sact, s_sactid, s_sptr, s_sprodid, s_sprod } = window;
        let brandParts = s_sptr != null ? s_sptr.split(" ") : [];
        let tracking = {
            moduleName: "vidrecap"
        }

        let videoEl = document.querySelector('[data-module="streaming-video-player"]');
        if(!videoEl) return Promise.reject('videoEl:[data-module="streaming-video-player"] not found');
        let videoLoader = new VideoLoader(videoEl, tracking);
        let promise = new Promise((resolve, reject) => {
            videoLoader.load()
                .then((configData) => {

                        let { videoSettings, controlsSettings, apiData } = configData;
                        this.videoApiData = apiData;
                        videoSettings.videoId = "video1";

                        this.videoSettings = videoSettings;
                        let self = this;
                        let svpLoader = new SVPLoader();
                        svpLoader.loadSVPLibrary().then(res => {
                            let svp = new Medscape.modules.StreamingVideoPlayer(videoEl,videoSettings,tracking);
                           window.svp = svp;
                            self.SVP = svp;
                            svp.create().then(event => {
                                    self.amp = event.player;
                                    resolve(event);
                                    return event;
                                },
                                error => {
                                    videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
                                    reject(error);
                                })
                        })
                    }, //End  video library Code
                    error => {
                        videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
                        reject(error);
                    })
        });
        return promise;
    }
    insert800Ad(adId, pos) {
        // insert pos 800 and 1800 ads
        profads.ads2.insertAdElement({
            id: adId,
            pos: pos,
            collapseAfter: true,
            beforeOrAfter: 'insertBefore',
            targetElement: Array.from(document.querySelectorAll('.page-body > div')).pop()
        });
        return this;
    }
    
    setAboutHoverContent() {        
        let MedicalMinutesText =  `<div class="medical-minutes-about-block">
             <a class="title">About Medscape Medical Minute </a>
             <div class="medical-minutes-tooltip" >
                <span class="medical-minutes-desc">
                Dr. Perry Wilson highlights the day’s top news stories, produced by Medscape, the leading source of information for medical professionals. From new clinical evidence to breaking policy news, stay on the pulse of medicine with Medscape Medical Minute.
                </span>
            </div>
        </div>`
        $("#article-content").after(MedicalMinutesText);
        this.setTooltip();
        
    } 
    setTooltip() {
        $(".medical-minutes-tooltip").hide();
        $(document).on("mouseenter", ".medical-minutes-about-block .title", function () {
            $(".medical-minutes-tooltip").show();
        }).on("mouseleave", ".medical-minutes-about-block .title", function () {
            $(".medical-minutes-tooltip").hide();
        });
    }
    loadAds() {
	if (PageMetadata.reqHeaders.device == "MOBILE"||window.breakpoint == 1 ) {

		$("#bodypadding").append(
            `<div id="ads-pos-1520" class="AdUnit"></div>
             <div id="ads-pos-1909" class="AdUnit"></div>`); // removed <div id="ads-pos-1420" class="AdUnit"></div>
             delete window.ads2_ignore["1520"];
             delete window.ads2_ignore["1420"];
             delete window.ads2_ignore["1909"];
				 webmd.ads2.defineAd({
					 id: 'ads-pos-1909',
					 pos: '1909'
				 }); 
				 webmd.ads2.defineAd({
					 id: 'ads-pos-1520',
					 pos: '1520'
				 });
                // removed defined 1420 
				//  webmd.ads2.defineAd({
				// 	 id: 'ads-pos-1420',
				// 	 pos: '1420'
				//  }); 
	 }
     else {
		$("#bodypadding").append(
            `<div id="ads-pos-909" class="AdUnit"></div>
             <div id="ads-pos-520" class="AdUnit"></div>`); // removed <div id="ads-pos-420" class="AdUnit"></div>
             delete window.ads2_ignore["420"];
             delete window.ads2_ignore["909"];
             delete window.ads2_ignore["520"];
				 webmd.ads2.defineAd({
					 id: 'ads-pos-909',
					 pos: '909'
				 }); 
				 webmd.ads2.defineAd({
					 id: 'ads-pos-520',
					 pos: '520'
				 }); 
				// removed defined 420
                 //  webmd.ads2.defineAd({
				// 	 id: 'ads-pos-420',
				// 	 pos: '420'
				//  }); 
     }
     
    } 
    hideBreadCrumb() {
        let breadcrumbMM =document.getElementsByClassName("breadcrumb")[0].children[1].outerHTML;
        document.getElementsByClassName("breadcrumb")[0].innerHTML = breadcrumbMM;
    }

    addEventListnerForIFI () {
        window.addEventListener('message', (e) => {
            let message = typeof e.data == "string" && e.data.indexOf("loadIfiVideo") > 0 ? JSON.parse(e.data) :"";
            if(message.callback && message.callback == "loadIfiVideo") {
                this.loadSponsoredVideo(message['payload']);
            }
        });
    }
    loadSponsoredVideo(config = null) {
        if (isNaN(config.video.duration)) {
            config.video.duration = getSecondsFromTimeString(config.video.duration);
        }
        this.sponsoredVideoData = config;

        const { player } = this;
        if(player == null){
            this.PlayerReadyCallbacks.push(() => {
                this.loadSponsoredVideo(config);
            })
        }
        else {
            this.sponsoredVideo = new SponsoredVideo(config, this.SVP);
            this.sponsoredVideo.init();
            this.loadPlaylist().then(playlist => {
                var timeIntervals = [25, 50, 75];
                var startStop = [true, true];
                this.sticky.setIFIVideo(this.sponsoredVideoData.title, ".content-container.ifi .flex-content");
                player.AmpEventsSources["mediachange"].subscribe(eventData => {
                    if (eventData.videoId == "ifivideo") {
                        if (typeof this.sponsoredVideoData.video["trackingPixel-Start"] == "string" && startStop[0]) {
                            this.loadTrackingPixel(this.sponsoredVideoData.video["trackingPixel-Start"]);
                            startStop[0] = false;
                        }
                        this.sticky.setStickyTitle(config,true);
                        this.sticky.setNextVideo(this.nextVideoUrl, this.nextVideoTitle);
                        player.AmpEventsSources["timeupdate"].subscribe(_event => {
                            let { currentTime, duration } = player;
                            let timePercent = (currentTime / duration) * 100;
                            if (_event.videoId == "ifivideo") {
                                timeIntervals.forEach((timeInterval, i) => {
                                    if (timePercent > timeInterval) {
                                        timeIntervals.splice(i, 1);
                                        if (this.sponsoredVideoData.video[`trackingPixel-${timeInterval}`]) {
                                            this.loadTrackingPixel(this.sponsoredVideoData.video[`trackingPixel-${timeInterval}`]);
                                        }
                                    }
                                });
                            }
                        });
                        player.AmpEventsSources["ended"].subscribe(___event => {
                            if (___event.videoId == "ifivideo" && this.sponsoredVideoData.video[`trackingPixel-100`] && startStop[1]) {
                                this.loadTrackingPixel(this.sponsoredVideoData.video[`trackingPixel-100`]);
                                startStop[1] = false;
                            }
                            if (___event.videoId == "ifivideo" && this.nextVideoUrl) {
                                this.autoPlayNextVideo();
                            }
                        });
                    }
                    else {
                        this.sticky.setIFIVideo(this.sponsoredVideoData.title, ".content-container.ifi .flex-content");
                    }
                })
            })
        }

    }
    loadTrackingPixel(trackPix) {
        const timestamp = new Date().getTime().toString();
        const trackPixWithTimeStamp = trackPix.replace("[timestamp]", timestamp);
        const trackImg = `<img src=${trackPixWithTimeStamp} height="1" width="1" alt="Advertisement">`;
        if(trackPix) {
            $(".playlist-container").append(trackImg);
        }
    }

    loadPlaylist() {
        const { videoSettings, sponsoredVideoData, videoApiData, sponsoredVideo } = this;
        const { videoConfig: sponsoredVideoConfig } = sponsoredVideoData ? sponsoredVideo: "";
        const playlistTheme = sponsoredVideoData ? sponsoredVideoData.playlist.theme: "dark";
        let thumbnail = videoApiData.config.poster;
        if (typeof(thumbnail) == 'undefined' || thumbnail.trim() == '') {
            thumbnail = videoApiData.config.bumperImage;
        }
        let playListApi = new PlayListAPI();
        let videoData = {
            "isIfi": false,
            "isPlaylist": false,
            "playlist": {
                "thumbnail": thumbnail,
                "header": "",
                "title": playListApi.enhanceTitleForViewability(videoSettings.title)
            },
            "video": videoSettings
        }
        let ifiVideo;
        let ifiData = {};

        if(typeof sponsoredVideoConfig == "object") {
            ifiVideo = Object.assign({}, sponsoredVideoData.video, {
                title: sponsoredVideoConfig.title
            });
            ifiData = {
                "isIfi": true,
                "isPlaylist": false,
                "playlist": {
                    "title": playListApi.enhanceTitleForViewability(sponsoredVideoConfig.title)
                },
                "video": ifiVideo
            }
            ifiData.playlist = Object.assign({}, ifiData.playlist, sponsoredVideoData.playlist);
        }
        let playListVideo = this.playlistVideos.length > 0 ? this.playlistVideos : [];
        this.playlistVideos = this.playlistVideos.map(e => {
            if (e.playlist != "undefined") {
                if(e.video == "current video") {
                    e["video"] = videoSettings;
                    return e
                }
                return e
            }
        })
        let playlistItems = playListVideo;
        if( this.nextVideoIndex > 0 && typeof sponsoredVideoConfig == "object") {
            playlistItems.splice(this.nextVideoIndex, 0, ifiData);
        } else if (typeof ifiVideo == "object") {
            playlistItems = [videoData, ifiData];
        }

        // let playlistItems = typeof ifiVideo == "object" ? [videoData, ifiData, ...playListVideo]: [videoData, ...playListVideo];

        let playlist = new Playlist(playlistItems, this.SVP, "dark", this.sticky);
        return playlist.create().then(playlist => {
            this.playlist = playlist;
            let container = document.getElementById('eed-video');
            if(!container) container = document.getElementById('cme-video-player').parentNode;
            let playlistContainer = document.createElement('div');

            playlistContainer.classList.add('playlist-container');

            playlistContainer.appendChild(playlist.el);
            if($(".playlist-container").length > 0) {
                $(".playlist-container").remove();
                // this.recapTemp.createCarousel();
            }
            container.appendChild(playlistContainer);
            this.playlistContainer = playlistContainer;
            let headingEl = document.querySelector('.title-area .heading');
            headingEl.classList.add('theme-dark');
            headingEl.classList.add('has-playlist');
            setTimeout(() => {
                playlist.el.classList.add("ready");
            }, 10);
            return playlist;

        })
    }
}

let medicalMinutesArticle = new MedicalMinutesArticle(document.getElementById('bodypadding'));
medicalMinutesArticle.init();